import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockText from "../../Block/BlockText";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";

function ColorTransferLib() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light">
        <BlockContent>
          <BlockTitle>ColorTransferLib</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>WIP</BlockText>
        </BlockContent>
      </Block>





      <Block>
        <BlockContent width="100%"  textAlign="center">
          <BlockTitle>Comming Soon</BlockTitle>
        </BlockContent>
      </Block>

      <Block colorTheme="light"> 
        <BlockContent width="10%" color="grey" fontStyle="italic">
          <BlockButton>GitHub</BlockButton>
        </BlockContent>
      </Block>


      <Footer/>
    </div>
  );
}

export default ColorTransferLib;